import React, { useState, useEffect, useCallback } from "react";
import {
  Drawer,
  Box,
} from "@mui/material";
import LeadDetails from "./LeadDetails";
import { campaignManagementService } from "services/campaign";
import { DEFAULT_TOKEN } from "utilities/constants";
import { RootState } from "store";
import { useSelector } from "react-redux";
import LeadDetailsSkeleton from "../PreLoadSkeletons/LeadDetailsSkeleton";

interface LeadDetailsDrawerProps {
  open: boolean;
  onClose: () => void;
  candidateDetails: {
    username: string;
    jobId: string;
    expertId: string;
    campaignId: string;
    black_list?: boolean;
    priority_list?: boolean;
    lead_info?: {
      lead_id: string;
      lead_name: string;
    };
  };
  openFeedBackModal: () => void;
  setSelectedUserName: (username: string) => void;
  onCandidateDrawerClose: () => void;
}

const LeadDetailsDrawer: React.FC<LeadDetailsDrawerProps> = ({
  open,
  onClose,
  candidateDetails,
  openFeedBackModal,
  setSelectedUserName,
  onCandidateDrawerClose,
}) => {
  const [profileData, setProfileData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [actionsPerformed, setActionsPerformed] = useState(false);
  const expertId = useSelector((state: RootState) => state.auth.user.expertId);

  const fetchCandidateLeadDetails = useCallback(async () => {
    if (!candidateDetails?.username) return;

    setLoading(true);
    try {
      const payload = {
        token: DEFAULT_TOKEN,
        userName: candidateDetails.username,
        expertId: candidateDetails.expertId,
        jobId: candidateDetails.jobId,
        campaignId: candidateDetails.campaignId
      };
      const response = await campaignManagementService.getCandidateLeadDetails(payload);

      setProfileData({
        ...response.output,
        lead_info: candidateDetails.lead_info,
        evaluationDetails: response.output.evaluationDetails,
        username: candidateDetails.username,
        jobId: candidateDetails.jobId,
        expertId: candidateDetails.expertId,
        campaignId: candidateDetails.campaignId,
        black_list: candidateDetails.black_list,
        priority_list: candidateDetails.priority_list 
      });
    } catch (error) {
      console.error("Failed to fetch candidate details:", error);
    } finally {
      setLoading(false);
    }
  }, [candidateDetails]);

  useEffect(() => {
    if (open) {
      fetchCandidateLeadDetails();
      
      setActionsPerformed(false);
    }
  }, [candidateDetails, expertId, open, fetchCandidateLeadDetails]);

  const handleClose = () => {
    onClose();
    
    if (actionsPerformed) {
      onCandidateDrawerClose();
    }
  };

  const handleActionPerformed = () => {
    setActionsPerformed(true);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      transitionDuration={500}
      PaperProps={{
        sx: {
          width: "94.5%",
          background: "#F5F7F9",
          marginTop: "3%",
        },
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
          <LeadDetailsSkeleton />
        </Box>
      ) : (
        profileData && (
          <LeadDetails
            key={profileData?.username + profileData?.black_list}
            candidateData={profileData}
            onClose={handleClose}
            openFeedBackModal={openFeedBackModal}
            setSelectedUserName={setSelectedUserName}
            onActionPerformed={handleActionPerformed}
          />
        )
      )}
    </Drawer>
  );
};

export default LeadDetailsDrawer;
